var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDelete1 = function SvgDelete1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5138 9.35156C19.5138 9.35156 18.9776 16.0096 18.6666 18.8141C18.5184 20.1536 17.6919 20.9386 16.338 20.9633C13.7616 21.0097 11.1822 21.0127 8.60673 20.9583C7.30419 20.9316 6.49147 20.1368 6.3463 18.8211C6.03326 15.9918 5.5 9.35156 5.5 9.35156",
    fill: "#C83333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5625 7.23851C4.5625 6.65374 4.93758 6.17969 5.40027 6.17969H19.6071C20.0698 6.17969 20.4449 6.65374 20.4449 7.23851C20.4449 7.82328 20.0698 8.29733 19.6071 8.29733H5.40027C4.93758 8.29733 4.5625 7.82328 4.5625 7.23851Z",
    fill: "#C83333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93228 4.63067C9.15347 3.66614 9.90256 3 10.7547 3H14.2565C15.1086 3 15.8577 3.66614 16.0789 4.63067C16.0835 4.65056 16.0875 4.67061 16.091 4.6908L16.2919 5.86324C16.3421 6.15458 16.5622 6.36513 16.8168 6.36513C17.2736 6.36513 17.644 6.79695 17.644 7.32962C17.644 7.8623 17.2736 8.29412 16.8168 8.29412C15.7726 8.29412 14.8743 7.43388 14.6696 6.24202L14.4756 5.11008C14.4436 5.00259 14.3565 4.92899 14.2565 4.92899H10.7547C10.6547 4.92899 10.5676 5.0026 10.5356 5.11008L10.3416 6.24163C10.1369 7.43349 9.23855 8.29412 8.19443 8.29412C7.73756 8.29412 7.36719 7.8623 7.36719 7.32962C7.36719 6.79695 7.73756 6.36513 8.19443 6.36513C8.44896 6.36513 8.66902 6.15496 8.71922 5.86363L8.92024 4.6908C8.9237 4.67061 8.92771 4.65056 8.93228 4.63067Z",
    fill: "#C83333"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDelete1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "delete1.7a5cbe6e8b23af70d514c5f7f1cde205.svg";